module.exports = __webpack_public_path__ + "static/scale-model-of-chesapean-outdoors-in-virginia-beach-virginia-dbc2c24d73155b5aa3c7d3c4dad3b67c.png";